// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trainer-pitching-wrapper {
    min-height: 100vh;
    background-color: #0F0125;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 100px 0px;
}

.trainer-pitching-wrapper .profile-sec-wrap {
    justify-content: space-between;
    min-width: 750px;
    margin: 0 auto;
    position: relative;
}

.trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap {
    text-align: center;
    position: absolute;
    top: 10%;
    display: block;
    right: -42%;
}

.trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap .mid-title {
    text-align: center;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
}

.trainer-pitching-wrapper .logo-img {
    max-width: 150px;
    margin-bottom: 20px;
}

.trainer-pitching-wrapper .heading {
    font-size: 26px;
    font-weight: 700;
    line-height: 75px;
    color: white;
    text-align: center;
    margin-bottom: 10px;
    width: unset;
}

.trainer-pitching-wrapper .sub-title {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    padding-bottom: 20px;
}

.trainer-pitching-wrapper .pitch-btn-pink {
    color: #242424;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    background-color: #F495D3;
    padding: 6px 20px;
    border-radius: 7px;
    margin-bottom: 30px;
}

.trainer-pitching-wrapper .user-name {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #ffff;
}

.trainer-pitching-wrapper .user-name span {
    font-weight: 700;
}

.trainer-pitching-wrapper .icon-title {
    font-size: 12px;
    font-weight: 400;
    line-height: 35px;
}

.trainer-pitching-wrapper .profile-section-trainer {
    margin-bottom: 40px;
    max-width: 280px;
    margin: 0 auto;
}

.trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap .user-name {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    padding: 24px 0px;

}


.trainer-pitching-wrapper .profile-img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-bottom: 10px;
}

.trainer-pitching-wrapper .icons {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 10px;
}

.trainer-pitching-wrapper .icon-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.trainer-pitching-wrapper .icon-img {
    width: 40px;
    height: 40px;
}

.trainer-pitching-wrapper .bottom-content {
    justify-content: center;
    overflow: hidden;
}

.trainer-pitching-wrapper .bottom-content .description {
    max-width: 582px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 14px;
    line-height: 35px;
    padding-bottom: 26px;
}

.trainer-pitching-wrapper .bottom-content .prepare-button {
    background-color: #06EFC5;
    /* padding: 18px 59px; */
    height: 50px;
    width: 310px;
    font-size: 18.33px;
    font-weight: 800;
    line-height: 13.33px;
    color: #242424;
    cursor: pointer;
    border-radius: 0px;
    display: inline-block;
}

.trainer-pitching-wrapper .bottom-content .prepare-button-mob {
    background-color: #06EFC5;
    padding: 18px 59px;
    font-size: 18.33px;
    font-weight: 800;
    line-height: 13.33px;
    color: #242424;
    cursor: pointer;
    border-radius: 0px;
    display: none;
}

.trainer-pitching-wrapper .bottom-content .prepare-button:focus {
    box-shadow: none;
}

.trainer-pitching-wrapper .bottom-content .bottom-line {
    font-weight: 400;
    line-height: 20px;
    font-size: 16px;
    color: #ffff;
    padding: 18px 54px;
    background-color: #1e102d;
    width: max-content;
    margin: 28px auto 0px;
}

.trainer-pitching-wrapper .profile-sec-wrap .mob-title-pitch {
    display: none;
}

@media(max-width: 1650px) {
    .trainer-pitching-wrapper {
        padding: 30px 0px 10px;
    }

    .trainer-pitching-wrapper .logo-img {
        margin-bottom: 0px;
    }

    .trainer-pitching-wrapper .heading {
        line-height: 40px;
    }

    .trainer-pitching-wrapper .pitch-btn-pink {
        margin-bottom: 10px;
    }

    .trainer-pitching-wrapper .bottom-content .description {
        line-height: 28px;
    }

    .trainer-pitching-wrapper .bottom-content .description {
        padding-bottom: 10px;
    }
}

@media(max-width: 767px) {
    .trainer-pitching-wrapper {
        padding: 50px 20px 22px;
    }

    .trainer-pitching-wrapper .profile-sec-wrap {
        min-width: 100%;
    }

    .trainer-pitching-wrapper .heading {
        line-height: 24px;
        font-size: 16px;
        max-width: 320px;
        margin: 0 auto;
        padding-bottom: 30px;
    }

    .trainer-pitching-wrapper .profile-img {
        width: 100px;
        height: 100px;
    }

    .trainer-pitching-wrapper .profile-section-trainer .caller-title {
        font-size: 14px;
        line-height: 22px;
    }

    .trainer-pitching-wrapper .profile-section-trainer .caller-name {
        font-size: 14px;
        line-height: 22px;
    }

    .trainer-pitching-wrapper .bottom-content .description {
        font-size: 12px;
        line-height: 20px;
        opacity: 50%;
        padding: 20px 0px;
    }

    .trainer-pitching-wrapper .bottom-content .bottom-line {
        font-size: 10px;
    }

    .trainer-pitching-wrapper .pitching-user {
        display: flex;
        background-color: rgba(255, 255, 255, 0.13);
        border-radius: 12px;
        margin-bottom: 6px;
        padding: 6px;
    }

    .trainer-pitching-wrapper .profile-section-trainer {
        max-width: unset;
        padding-bottom: 30px;
    }

    .trainer-pitching-wrapper .pitching-user img {
        width: 28px;
        height: 28px;
    }

    .trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap {
        display: none;
    }

    .trainer-pitching-wrapper .profile-sec-wrap .mob-title-pitch {
        display: block;
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        text-align: left;
        padding: 18px 0px 7px;
    }

    .trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap .mid-title {
        text-align: left;
        font-size: 12px;
        padding-bottom: 7px;
    }

    .trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap {
        flex-direction: column;
    }

    .trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap .user-name {
        font-size: 12px;
        padding: 0px 0px 0px 14px;
    }

    .trainer-pitching-wrapper .bottom-content .prepare-button-mob {
        display: inline-block;
        width: 100%;
    }

    .trainer-pitching-wrapper .bottom-content .prepare-button {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/TrainerPitching/TrainerPitching.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;AAErB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,2CAA2C;QAC3C,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".trainer-pitching-wrapper {\n    min-height: 100vh;\n    background-color: #0F0125;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 100px 0px;\n}\n\n.trainer-pitching-wrapper .profile-sec-wrap {\n    justify-content: space-between;\n    min-width: 750px;\n    margin: 0 auto;\n    position: relative;\n}\n\n.trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap {\n    text-align: center;\n    position: absolute;\n    top: 10%;\n    display: block;\n    right: -42%;\n}\n\n.trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap .mid-title {\n    text-align: center;\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n}\n\n.trainer-pitching-wrapper .logo-img {\n    max-width: 150px;\n    margin-bottom: 20px;\n}\n\n.trainer-pitching-wrapper .heading {\n    font-size: 26px;\n    font-weight: 700;\n    line-height: 75px;\n    color: white;\n    text-align: center;\n    margin-bottom: 10px;\n    width: unset;\n}\n\n.trainer-pitching-wrapper .sub-title {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    padding-bottom: 20px;\n}\n\n.trainer-pitching-wrapper .pitch-btn-pink {\n    color: #242424;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    background-color: #F495D3;\n    padding: 6px 20px;\n    border-radius: 7px;\n    margin-bottom: 30px;\n}\n\n.trainer-pitching-wrapper .user-name {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    color: #ffff;\n}\n\n.trainer-pitching-wrapper .user-name span {\n    font-weight: 700;\n}\n\n.trainer-pitching-wrapper .icon-title {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 35px;\n}\n\n.trainer-pitching-wrapper .profile-section-trainer {\n    margin-bottom: 40px;\n    max-width: 280px;\n    margin: 0 auto;\n}\n\n.trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap .user-name {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    padding: 24px 0px;\n\n}\n\n\n.trainer-pitching-wrapper .profile-img {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    margin-bottom: 10px;\n}\n\n.trainer-pitching-wrapper .icons {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-top: 10px;\n}\n\n.trainer-pitching-wrapper .icon-button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.trainer-pitching-wrapper .icon-img {\n    width: 40px;\n    height: 40px;\n}\n\n.trainer-pitching-wrapper .bottom-content {\n    justify-content: center;\n    overflow: hidden;\n}\n\n.trainer-pitching-wrapper .bottom-content .description {\n    max-width: 582px;\n    margin: 0 auto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 35px;\n    padding-bottom: 26px;\n}\n\n.trainer-pitching-wrapper .bottom-content .prepare-button {\n    background-color: #06EFC5;\n    /* padding: 18px 59px; */\n    height: 50px;\n    width: 310px;\n    font-size: 18.33px;\n    font-weight: 800;\n    line-height: 13.33px;\n    color: #242424;\n    cursor: pointer;\n    border-radius: 0px;\n    display: inline-block;\n}\n\n.trainer-pitching-wrapper .bottom-content .prepare-button-mob {\n    background-color: #06EFC5;\n    padding: 18px 59px;\n    font-size: 18.33px;\n    font-weight: 800;\n    line-height: 13.33px;\n    color: #242424;\n    cursor: pointer;\n    border-radius: 0px;\n    display: none;\n}\n\n.trainer-pitching-wrapper .bottom-content .prepare-button:focus {\n    box-shadow: none;\n}\n\n.trainer-pitching-wrapper .bottom-content .bottom-line {\n    font-weight: 400;\n    line-height: 20px;\n    font-size: 16px;\n    color: #ffff;\n    padding: 18px 54px;\n    background-color: #1e102d;\n    width: max-content;\n    margin: 28px auto 0px;\n}\n\n.trainer-pitching-wrapper .profile-sec-wrap .mob-title-pitch {\n    display: none;\n}\n\n@media(max-width: 1650px) {\n    .trainer-pitching-wrapper {\n        padding: 30px 0px 10px;\n    }\n\n    .trainer-pitching-wrapper .logo-img {\n        margin-bottom: 0px;\n    }\n\n    .trainer-pitching-wrapper .heading {\n        line-height: 40px;\n    }\n\n    .trainer-pitching-wrapper .pitch-btn-pink {\n        margin-bottom: 10px;\n    }\n\n    .trainer-pitching-wrapper .bottom-content .description {\n        line-height: 28px;\n    }\n\n    .trainer-pitching-wrapper .bottom-content .description {\n        padding-bottom: 10px;\n    }\n}\n\n@media(max-width: 767px) {\n    .trainer-pitching-wrapper {\n        padding: 50px 20px 22px;\n    }\n\n    .trainer-pitching-wrapper .profile-sec-wrap {\n        min-width: 100%;\n    }\n\n    .trainer-pitching-wrapper .heading {\n        line-height: 24px;\n        font-size: 16px;\n        max-width: 320px;\n        margin: 0 auto;\n        padding-bottom: 30px;\n    }\n\n    .trainer-pitching-wrapper .profile-img {\n        width: 100px;\n        height: 100px;\n    }\n\n    .trainer-pitching-wrapper .profile-section-trainer .caller-title {\n        font-size: 14px;\n        line-height: 22px;\n    }\n\n    .trainer-pitching-wrapper .profile-section-trainer .caller-name {\n        font-size: 14px;\n        line-height: 22px;\n    }\n\n    .trainer-pitching-wrapper .bottom-content .description {\n        font-size: 12px;\n        line-height: 20px;\n        opacity: 50%;\n        padding: 20px 0px;\n    }\n\n    .trainer-pitching-wrapper .bottom-content .bottom-line {\n        font-size: 10px;\n    }\n\n    .trainer-pitching-wrapper .pitching-user {\n        display: flex;\n        background-color: rgba(255, 255, 255, 0.13);\n        border-radius: 12px;\n        margin-bottom: 6px;\n        padding: 6px;\n    }\n\n    .trainer-pitching-wrapper .profile-section-trainer {\n        max-width: unset;\n        padding-bottom: 30px;\n    }\n\n    .trainer-pitching-wrapper .pitching-user img {\n        width: 28px;\n        height: 28px;\n    }\n\n    .trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap {\n        display: none;\n    }\n\n    .trainer-pitching-wrapper .profile-sec-wrap .mob-title-pitch {\n        display: block;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 22px;\n        text-align: left;\n        padding: 18px 0px 7px;\n    }\n\n    .trainer-pitching-wrapper .profile-sec-wrap .profile-image-wrap .mid-title {\n        text-align: left;\n        font-size: 12px;\n        padding-bottom: 7px;\n    }\n\n    .trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap {\n        flex-direction: column;\n    }\n\n    .trainer-pitching-wrapper .profile-section-trainer .pitching-user-wrap .user-name {\n        font-size: 12px;\n        padding: 0px 0px 0px 14px;\n    }\n\n    .trainer-pitching-wrapper .bottom-content .prepare-button-mob {\n        display: inline-block;\n        width: 100%;\n    }\n\n    .trainer-pitching-wrapper .bottom-content .prepare-button {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
